/**
 * Application configuration
 * Update these values with your Azure AD credentials
 */
export const appConfig = {
  // Azure AD Application (client) ID
  clientId: '7362de85-c7d3-4137-bb84-e853e5290b1b',

  // Azure AD Directory (tenant) ID
  tenantId: '3af3ed18-6578-404a-b7c1-654ad73a244e',

  // Optional: Redirect URI (defaults to window.location.origin)
  redirectUri: 'https://ts.roomready.io',
};